import { render } from "./home_page.vue?vue&type=template&id=56344c36&scoped=true"
import script from "./home_page.vue?vue&type=script&lang=js"
export * from "./home_page.vue?vue&type=script&lang=js"

import "./home_page.vue?vue&type=style&index=0&id=56344c36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56344c36"]])

export default __exports__